import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import ReportTable from "../../componentsShared/ReportTable";
import ReportTableHeader from "../../componentsShared/ReportTableHeader";
import ViewAllButton from "../../componentsShared/ViewAllButton";
import "./style.scss";

const columns = [
  {
    title: "SKU",
    dataIndex: "name",
    width: "40%",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
    showSorterTooltip: false,
  },
  {
    title: "Type",
    dataIndex: "type",
    width: "20%",
    align: "center",
    key: "type",
    sorter: (a, b) => a.type.localeCompare(b.type),
    showSorterTooltip: false,
  },
  {
    title: "Date",
    dataIndex: "date",
    width: "40%",
    align: "center",
    key: "date",
    sorter: (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
    showSorterTooltip: false,
  },
];

const NewSKUDetected = ({ data }) => {
  const [tableConfigs, setTableConfigs] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTableConfigs(columns);
  }, []);

  return (
    <div className="OverdueStoreAudits-wp">
      <ReportTableHeader
        title="SKU Changes Detected"
        hideControlButtons={true}
      />
      <div className="separate-line" />
      <ReportTable
        columns={tableConfigs}
        dataSource={data}
        isPagination={true}
      />
      <Modal
        title="SKU Changes Detected"
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={() => setVisible(false)}
        footer={null}
        width={600}
      >
        <ReportTable
          columns={tableConfigs}
          dataSource={data}
        />
      </Modal>
      <div className="view-all-btn-wp">
        <ViewAllButton title="View all" onClick={() => setVisible(true)} />
      </div>
    </div>
  );
};

export default NewSKUDetected;
